<template>
    <section id="page-slot" class="page-slot page">

        <div class="page__content">
            <div class="container">
                <div class="row">
                    <div class="col-12-sm col-2"></div>
                    <div class="col-12-sm col-8">
                        <img class="page-splash__logo" src="../../assets/images/logo.png">
                        <p>Dank voor het invullen. We hebben jouw persoonlijke profiel naar je gestuurd!</p>
                        <p>Mocht je deze na enige tijd nog niet hebben ontvangen, controleer dan je 'ongewenste e-mail'.
                            Mocht je profiel ook daar niet te vinden zijn, stuur dan een e-mail naar
                            <a href="mail:info@hybridedocent.com">info@hybridedocent.com</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style lang="stylus">

</style>
<script>

    export default {

    }
</script>



// WEBPACK FOOTER //
// page-slot.vue?5af98997